module.exports = __webpack_public_path__ + "static/gallery-13@2x-5ff23981f34dc63c69d59990c8258d6d.jpg";